import React from 'react'
import Footer from '../../../general/footer/Footer';

import client2 from '../../../assets/client2.jpg'
import img2 from "../../../assets/img2.jpg";
import smeimg1 from "../../../assets/smeimg1.webp"
import { Link } from 'react-router-dom';

const SME = () => {
    return (
        <div>
            <div className="insurance-section">
                <div className="insurance-content">
                    <div className="breadcrumb">
                        <span>Home</span> &nbsp;•&nbsp;
                        <span>Our Services</span> &nbsp;•&nbsp;
                        <span className="active">SME IPO Advisory</span>
                    </div>
                    <h1>SME IPO Advisory</h1>
                    <p>
                        At PSJ Capital Ventures, we help SMEs plan and execute their IPO journey with confidence. From determining eligibility to preparing documentation and connecting with SEBI-registered Merchant Bankers, we ensure every step is backed by expertise, precision, and strategic intent.
                    </p>
                </div>
                <div className="insurance-image">
                    <img src={smeimg1} alt="Insurance Family" />
                </div>
            </div>

            <div className="travel-details-container">
                {/* LEFT SECTION */}
                <div className="travel-details-left">
                    <h2>What Is SME IPO Advisory?</h2>
                    <p>
                        An SME IPO (Initial Public Offering) allows small and medium-sized enterprises to raise capital by listing on platforms like NSE Emerge or BSE SME. For many businesses, this is a major milestone—it opens the door to external funding, builds market credibility, and marks a transition into a more transparent and structured phase of growth.
                    </p>

                    <h3 style={{ color: 'black' }}>Why SMEs Should Consider an IPO</h3>

                    <h5>	•	Access to Long-Term Capital</h5>
                    <p className="bold-line">
                        An IPO allows you to raise funds for expansion, product development, or working capital—without increasing debt obligations.
                    </p>

                    <h5>•	Enhanced Brand Image and Visibility</h5>
                    <p className="bold-line">
                        A listed company enjoys higher visibility, which can boost customer trust, attract top talent, and build stronger supplier relationships.
                    </p>

                    <h5>•	Risk Distribution</h5>
                    <p className="bold-line">
                        Credit risk is distributed among all participating lenders, making it more acceptable to each one and enhancing your chances of approval.
                    </p>

                    <h5>•	Market-Based Valuation</h5>
                    <p className="bold-line">
                        Your company’s value is determined by the market, helping set benchmarks for future fundraising or strategic partnerships.
                    </p>


                    <h3 style={{ color: 'black' }}>Why Choose PSJ Capital Ventures</h3>
                    <div className="plan-columns">

                        <div>
                            <h5>1. 			Focused on SMEs</h5>
                            <p>We understand the challenges and ambitions of small and medium enterprises—we tailor every solution accordingly.
                            </p>
                            <h5>2. 			Strong Network of Merchant Bankers </h5>
                            <p>Our partnerships span across top-tier SEBI-registered Merchant Bankers, legal advisors, and audit firms.</p>
                        </div>
                        <div>
                            <h5>3. 			Structured, Transparent Process </h5>
                            <p>Our approach breaks down complex IPO steps into simple, actionable phases—keeping you informed and in control.</p>
                            <h5>4. 			Long-Term Perspective </h5>
                            <p>We don’t stop at listing. We help you prepare for life as a listed company—building systems that support sustainable growth and compliance.</p>
                        </div>
                    </div>

                    {/* Service Benefits */}
                    <div className="benefits-section">
                        <div className="benefits-image">
                            <img src={img2} alt="Service Benefits" />
                        </div>
                        <div className="benefits-list">
                            <h4>How We Help</h4>
                            {/* <p>
                                We help you invest across a wide spectrum of mutual fund categories:
                            </p> */}
                            <ul>
                                <li>✓ 	•			Feasibility & Eligibility Check  </li>
                                <li>✓ 	•			Pre-IPO Planning </li>
                                <li>✓ 	•			Merchant Banker Connection  </li>
                                <li> ✓	•			End-to-End Process Management  </li>
                                <li> ✓  •			Post-Listing Guidance  </li>
                            </ul>
                        </div>
                    </div>


                    {/* More Benefits */}
                    <div className="service-benefits">
                        <h3>Who Should Consider an SME IPO?</h3>

                        <ul>
                            <li>✓ 			Growth-stage companies seeking non-dilutive capital</li>
                            <li>✓ 			Businesses with a track record of profitability and consistent revenue</li>
                            <li>✓ 			SMEs from sectors like manufacturing, retail, technology, or services with potential to scale</li>
                            <li>✓ 			Promoters who want to professionalize the business and unlock value</li>
                            <li>✓ 			Companies looking to improve governance and build long-term institutional trust</li>
                        </ul>
                        <p>
                            Taking your business public is a bold step and we’re here to guide you through it. With the right preparation and trusted partners, an SME IPO can unlock new levels of growth and market credibility.

                        </p>
                    </div>
                    <Link to='/contact'><button className="get-touch-btn">Get in Touch →</button></Link>
                </div>

                {/* RIGHT SECTION */}
                <div className="travel-details-right">
                    <div className="services-box">
                        <h4>Our Services</h4>
                        <ul>
                            <Link to='/mutual-funds'><li>mutual-funds →</li></Link>
                            <Link to='/portfolio-management-services'><li>Portfolio Management Services →</li></Link>
                            <Link to='/alternative-investment-funds'><li>Alternative Investment Funds →</li></Link>
                            <Link to='/macro-treasury-research'><li>Macro/Treasury Research →</li></Link>
                            <Link to='/nri-corner'><li>NRI Corner →</li></Link>
                            <Link to='/family-offices'><li>Family Offices →</li></Link>
                            <Link to='/insurance'><li>Insurance →</li></Link>
                            <Link to='/loan-syndication'><li>Loan Syndication→</li></Link>
                            <Link to='/fundraising-assistance'><li>Fundraising Assistance →</li></Link>
                            <Link to='/stock-broking'><li>Stock Broking →</li></Link>
                        </ul>
                    </div>

                    <div className="advisor-box">
                        <img src={client2} alt="Advisor" />
                        <p>Make your dream life get professional help</p>
                        <div className="contact-info">
                            <span>📞 CONTACT US</span>
                            <p>+91 8108 430 942</p>
                        </div>
                    </div>
                </div>
            </div>
            <br></br><br></br><br></br>
            <Footer />
        </div>
    )
}

export default SME;